import React from 'react';
import { Confirmation } from 'layer7-apihub';

import { AuthenticationLayout } from './AuthenticationLayout';

export const ConfirmationPage = () => {
    return (
        <AuthenticationLayout>
            <Confirmation
                toolbarProps={{
                    button: {
                        variant: 'contained',
                    },
                }}
            />
        </AuthenticationLayout>
    );
};
